export default __webpack_public_path__ + "static/media/hai.d32ebed9.svg";